import React, {useState} from "react";
import './DropdownMenu.css';

type DropdownMenuProps = {

  links: {
    text: string,
    onClick: () => void;
  }[]
  
  // Optional - if you don't want the hamburge menu.
  buttonContent?: React.ReactNode,

}

export const DropdownMenu = (props: DropdownMenuProps) => {

  const [navLinksOpen, setNavLinksOpen] = useState(false);


  return <div className={'DropdownMenuButtonContainer'}>

    <button className={'DropdownMenuButton'}
            onClick={() => {
              setNavLinksOpen(open => !open)
            }}
            onBlur={() => {
              // Keeps the blur from happening before a click on an item.
              setTimeout(() => setNavLinksOpen(false), 150);
            }}>

      {props.buttonContent || <img src={require('../../images/icons/menu.png')} alt={'Menu'}
           style={{height: 30, width: 30}}/>}
    </button>

    {/* this div is an anchor for the relatively positioned overlay*/}
    <div style={{position: "relative"}}>

      {navLinksOpen && <div className={'DropdownMenuLinksOverlay'}>
        {props.links.map((link, i) => {
          return <div key={'link-' + i} className={'DropdownMenuLink'}
                      onClick={() => {
                        link.onClick();
                        setNavLinksOpen(false);
                      }}>
            {link.text}
          </div>
        })}
      </div>}
    </div>
  </div>
};